// 联系我们
<template>
  <div class="main">
    <div class="head">
      <myheadert></myheadert>
      <img src="~@/assets/aboutMe_img/u6086-4.png" class="title">
    </div>
    <div class="middle">
      <div class="location">
        <img src="~@/assets/common_img/house.png">
        <span class="place">您的位置：&nbsp;<span @click="goHome">主页</span>＞关于我们＞联系我们</span>
      </div>
      <div class="lead">
        <ul>
          <li><a href="#/introduce">企业简介</a></li>
          <li><a href="#/experience">成长历程</a></li>
          <li><a href="#/business">企业资质</a></li>
          <li><a href="#/address">企业地图</a></li>
          <li class="lead_five"><a href="#/contact">联系我们</a></li>
        </ul>
      </div>
      <div class="line"></div>
    </div>
    <div class="contact">
        <div class="contact-m">
          <img src="~@/assets/aboutMe_img/dizhi.png">
          <div class="contact-content">
            <p class="contact-title">公司地址：</p>
          <p class="content">北京经济技术开发区<br/>科创十四街20号院1号楼506</p>
          </div>
        </div>
        <div class="contact-m">
          <img src="~@/assets/aboutMe_img/email.png">
          <div class="contact-content">
            <p class="contact-title">公司邮箱：</p>
          <p class="content">kf@bjhzzykj.com</p>
          </div>
        </div>
        <div class="contact-m">
          <img src="~@/assets/aboutMe_img/tel.png">
          <div class="contact-content">
            <p class="contact-title">客服电话:</p>
          <p class="content">4008-505-010</p>
            <p class="content">邢工：13811663109</p>
          </div>
        </div>
        <div class="contact-m">
          <img src="~@/assets/aboutMe_img/chuanzhen.png">
          <div class="contact-content">
            <p class="contact-title">公司传真:</p>
          <p class="content">010-87925110转807</p>
          </div>
        </div>
        <div class="contact-m">
          <img src="~@/assets/aboutMe_img/phone.png">
          <div class="contact-content">
            <p class="contact-title">公司总机:</p>
          <p class="content">010-87925110</p>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
export default{
  name: 'contact',
  methods: {
    goHome () {
      this.$router.push(
        {
          path: '/'
        }
      )
      location.reload()
    }
  }
}
</script>
<style scoped>
@media screen and (min-width: 1500px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 900px;
  margin-top: 25px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: 1%;
  margin-left: 14.5%;
  font-size: 18px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 12%;
  height: 27px;
  float: left;
  text-align: center;
  line-height: 27px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 15px;
}
.lead_five{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 26px;
}
/* 联系我们 */
.contact{
  width: 70%;
  height: 400px;
  margin-top: 20px;
  margin-left: 15%;
  background-image: url('~@/assets/aboutMe_img/contact.jpg');
  background-size: 100% 100%;
  /* background-repeat: no-repeat; */
  padding-bottom: 50px;
  display: flex;
  flex-wrap:wrap;
  justify-content: space-around;
}
.contact img{
  width: 70%;
  height: 33%;
  padding-top: 10px;
}
.contact-m{
  width: auto;
}
.contact-title{
  font-size: 18px;
  color: white;
}
.content{
  font-size: 16px;
  color: white;
}
}
@media screen and (min-width: 1200px) and (max-width:1499px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 750px;
  margin-top: 20px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: -3%;
  margin-left: 14.5%;
  font-size: 18px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 15%;
  height: 27px;
  float: left;
  text-align: center;
  line-height: 27px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 15px;
}
.lead_five{
  background-color: #F15A24;
}
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 26px;
}
/* 联系我们 */
.contact{
  width: 70%;
  height: 400px;
  margin-top: 20px;
  margin-left: 15%;
  background-image: url('~@/assets/aboutMe_img/contact.jpg');
  background-size: 100% 100%;
  /* background-repeat: no-repeat; */
  padding-bottom: 50px;
  display: flex;
  flex-wrap:wrap;
  justify-content: space-around;
}
.contact img{
  width: 70%;
  height: 33%;
  padding-top: 10px;
}
.contact-m{
  width: auto;
}
.contact-title{
  font-size: 18px;
  color: white;
}
.content{
  font-size: 16px;
  color: white;
}
}
@media screen and (min-width: 960px) and (max-width:1199px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 600px;
  /* margin-left: 20px; */
  margin-top: 10px;
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  /* border: 1px red solid; */
  margin-top: -6%;
  margin-left: 14.5%;
  font-size: 16px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 20%;
  height: 27px;
  float: left;
  text-align: center;
  line-height: 27px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 15px;
}
.lead_five{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 26px;
}
/* 联系我们 */
.contact{
  width: 70%;
  height: 410px;
  margin-top: 20px;
  margin-left: 15%;
  background-image: url('~@/assets/aboutMe_img/contact.jpg');
  background-size: 100% 100%;
  /* background-repeat: no-repeat; */
  padding-bottom: 50px;
  display: flex;
  flex-wrap:wrap;
  justify-content: space-around;
}
.contact img{
  width: 70%;
  height: 33%;
  padding-top: 10px;
}
.contact-m{
  width: auto;
}
.contact-title{
  font-size: 18px;
  color: white;
}
.content{
  font-size: 16px;
  color: white;
}
}
@media screen and (min-width: 768px) and (max-width:959px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 400px;
  /* margin-left: 30px; */
  /* margin-top: 10px; */
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  /* border: 1px red solid; */
  margin-top: -11%;
  margin-left: 14.5%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 20%;
  height: 20px;
  float: left;
  text-align: center;
  line-height: 20px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 12px;
}
.lead_five{
  background-color: #F15A24;
}
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 20px;
}
/* 联系我们 */
.contact{
  width: 70%;
  height: 410px;
  margin-top: 20px;
  margin-left: 15%;
  background-image: url('~@/assets/aboutMe_img/contact.jpg');
  background-size: 100% 100%;
  /* background-repeat: no-repeat; */
  padding-bottom: 50px;
  display: flex;
  flex-wrap:wrap;
  justify-content: space-around;
}
.contact img{
  width: 70%;
  height: 33%;
  padding-top: 10px;
}
.contact-m{
  width: auto;
}
.contact-title{
  font-size: 18px;
  color: white;
}
.content{
  font-size: 16px;
  color: white;
}
}
@media screen and (min-width: 702px) and (max-width:767px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 500px;
  margin-left: 50px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: -12%;
  margin-left: 14.5%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 20%;
  height: 20px;
  float: left;
  text-align: center;
  line-height: 20px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 12px;
}
.lead_five{
  background-color: #F15A24;
}
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 20px;
}
/* 联系我们 */
.contact{
  width: 70%;
  height: 410px;
  margin-top: 20px;
  margin-left: 15%;
  background-image: url('~@/assets/aboutMe_img/contact.jpg');
  background-size: 100% 100%;
  /* background-repeat: no-repeat; */
  padding-bottom: 50px;
  display: flex;
  flex-wrap:wrap;
  justify-content: space-around;
}
.contact img{
  width: 70%;
  height: 33%;
  padding-top: 10px;
}
.contact-m{
  width: auto;
}
.contact-title{
  font-size: 18px;
  color: white;
}
.content{
  font-size: 16px;
  color: white;
}
}
@media screen and (max-width:701px){
  .main{
    width: 100%;
  }
  /* 顶部 */
.head{
  width: 100%;
  height: auto;
  background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.title{
  width: 50%;
  margin-left: 30%;
  margin-top: 10px;
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  /* border: 1px red solid; */
  margin-top: 10px;
  margin-left: 10%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 6%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
/* .lead{
  margin-left: 61%;
  margin-bottom: 0;
} */
.lead ul{
  list-style: none;
  margin-top: 20px;
}
.lead ul li{
  width: 20%;
  height: 14px;
  float: left;
  text-align: center;
  line-height: 12px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 12px;
}
.lead_five{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 34px;
}
/* 联系我们 */
.contact{
  width: 80%;
  height: auto;
  margin-top: 20px;
  margin-left: 10%;
  background-image: url('~@/assets/aboutMe_img/contact.jpg');
  background-size: 100% 100%;
  /* background-repeat: no-repeat; */
  padding-bottom: 50px;
  display: flex;
  flex-wrap:wrap;
  justify-content: space-around;
}
.contact img{
  width: 50%;
  height: 50%;
}
.contact-m{
  width: auto;
  /* border:1px solid red; */
}
.contact-title{
  font-size: 0.1rem;
  color: white;
  margin-left: 10%;
  /* text-align: center; */
}
.content{
  font-size: 0.1rem;
  color: white;
}
}
</style>



// WEBPACK FOOTER //
// src/components/aboutMe/contact.vue